export default __webpack_public_path__ + "static/media/budget-calculator.5c95de36.png";